module.exports = __webpack_public_path__ + "img/qrcode.31258d37.jpg";